<template>
  <v-menu
    content-class="notification-menu"
    nudge-top="10"
    transition="slide-y-transition"
    offset-y
    top
    :close-on-content-click="false"
    @input="onMenuChange"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        ref="notification-menu-btn"
        class="notification-menu__button"
        :class="{ 'has-new': newNotificationsCount }"
        color="#424242"
        dark
        v-bind="attrs"
        v-on="on"
        fab
        :disabled="buttonDisabled"
        @mousedown="dragButton"
      >
        <v-icon>mdi-bell</v-icon>
      </v-btn>
    </template>

    <v-tabs
      v-model="tab"
      class="notification-menu__tabs"
      color="#424242"
      fixed-tabs
    >
      <v-tab>{{ $t('notifications.tab.new') }}</v-tab>
      <v-tab>{{ $t('notifications.tab.read') }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <notification-list
          v-if="menuVisible"
          :loading="loading"
          :items="newNotifications"
        />
      </v-tab-item>
      <v-tab-item>
        <notification-list
          :loading="loading"
          :items="viewedNotifications"
          is-viewed
        />
      </v-tab-item>
    </v-tabs-items>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
import NotificationList from './NotificationList.vue';
import sound from '@/../static/notification-sound.mp3';

export default {
  components: { NotificationList },
  data: () => ({
    menuVisible: false,
    buttonDisabled: false,
    loading: false,
    tab: 0,
    interval: null,
  }),
  watch: {
    newNotificationsCount: {
      immediate: true,
      handler(newVal, prevVal) {
        if (newVal > prevVal) {
          this.playNotificationSound();
        }
      },
    },
  },
  computed: {
    ...mapState({
      notifications: ({ notifications }) => notifications.list,
    }),
    newNotifications() {
      return this.notifications.filter((item) => !item.is_viewed);
    },
    viewedNotifications() {
      return this.notifications.filter((item) => item.is_viewed);
    },
    newNotificationsCount() {
      return this.newNotifications.length;
    },
  },
  methods: {
    async fetchNotifications(loading = false) {
      this.loading = loading;
      await this.$store.dispatch('notifications/fetchList');
      this.loading = false;
    },

    onMenuChange(value) {
      if (value) this.menuVisible = true;
      else {
        setTimeout(() => {
          this.tab = 0;
          this.menuVisible = false;
        }, 300);
      }
    },

    dragButton(event) {
      let isButtonMoved = false;
      const btn = this.$refs['notification-menu-btn'].$el;

      const shiftX = event.clientX - btn.getBoundingClientRect().left;
      const shiftY = event.clientY - btn.getBoundingClientRect().top;

      const moveAt = (pageX, pageY) => {
        btn.style.left = `${pageX - shiftX}px`;
        btn.style.top = `${pageY - shiftY}px`;
      };

      const onMouseMove = (e) => {
        moveAt(e.clientX, e.clientY);
        isButtonMoved = true;
      };

      moveAt(event.clientX, event.clientY);

      document.addEventListener('mousemove', onMouseMove);

      btn.onmouseup = () => {
        document.removeEventListener('mousemove', onMouseMove);
        btn.onmouseup = null;

        // Prevent click event if btn moved
        if (isButtonMoved) {
          this.buttonDisabled = true;
          setTimeout(() => (this.buttonDisabled = false)); // eslint-disable-line
        }
      };
    },

    playNotificationSound() {
      const audio = new Audio(sound);
      audio.play();
    },
  },
  created() {
    this.fetchNotifications(true);
    this.interval = setInterval(() => this.fetchNotifications(), 60000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
.notification-menu {
  min-width: 350px !important;

  &__tabs {
    position: relative;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    z-index: 1;
  }

  &__button {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 9;

    &.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background: #424242 !important;
    }

    &.has-new::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid #fff;
      background-color: #fa4e4e;
      animation-name: scale;
      animation-duration: 300ms;
      animation-fill-mode: forwards;
    }

    @keyframes scale {
      0% {
        transform: scale(0);
      }

      100% {
        transform: scale(1);
      }
    }
  }
}
</style>
